import { render } from "./TheTradingBlocker.vue?vue&type=template&id=50861154&scoped=true"
const script = {}

import "./TheTradingBlocker.vue?vue&type=style&index=0&id=50861154&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50861154"]])

export default __exports__